import React, { useState, useEffect } from 'react';
import ImagePopupComponent from './ImagePopupComponent';

const ImagePopupContainer = props => {
    const { isShowImagePopup, onClickBtnCloseImagePopup, info, selectedImageIdx } = props;

    const [isShowOriginalSize, setIsShowOriginalSize] = useState(false);
    useEffect(_ => {
        setIsShowOriginalSize(false);
    }, [])

    const toggleImageSize = _ => {
        console.log('toggleImageSize', isShowOriginalSize)
        setIsShowOriginalSize(!isShowOriginalSize);
    }

    return (
        <ImagePopupComponent
            isShowImagePopup={isShowImagePopup}
            toggleImageSize={toggleImageSize}
            isShowOriginalSize={isShowOriginalSize}
            onClickBtnCloseImagePopup={onClickBtnCloseImagePopup}
            info={info}
            selectedImageIdx={selectedImageIdx}
            {...props} />
    )
}

export default ImagePopupContainer;